import React from 'react'
import { IconRefresh } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { BasicModal } from '@/components/layout/modals/BasicModal'

// Confirm before resetting a dashboard tab's layout. "Reset" is easily
// mistaken for clearing filters, but it discards the tab's widget/layout
// customization -- so gate it behind an explanatory modal.
//
// @param {() => void} props.onConfirm - run when the user confirms the reset
export const ResetTabConfirm = ({ onConfirm }) => (
  <BasicModal
    title="Reset this tab's layout?"
    trigger={(open) => (
      <Button basic onClick={open} title="Reset this tab's layout">
        <IconRefresh /> Reset
      </Button>
    )}
  >
    {(close) => (
      <>
        <p>
          This restores this tab&rsquo;s widgets and layout to the default arrangement, discarding
          any customizations you&rsquo;ve made to which widgets are shown and how they&rsquo;re
          arranged here.
        </p>
        <div className="form-actions is-modal">
          <Button onClick={close}>Cancel</Button>
          <Button
            destructive
            onClick={() => {
              onConfirm()
              close()
            }}
          >
            Reset layout
          </Button>
        </div>
      </>
    )}
  </BasicModal>
)
